import { PropsWithChildren } from 'react'
import { StyledEllipsisBox, StyledMentionable } from './styled'
import { Avatar, Box } from '@material-ui/core'
import { useTheme } from 'styled-components'
import { IMentionsSuggestionsListProps } from './MentionsSuggestionsList'
import { getHTMLTextLength } from 'common/utils/getHTMLTextLength'

export interface IMentionsResultListProps extends IMentionsSuggestionsListProps {}

export const MentionsResultList = (props: PropsWithChildren<IMentionsResultListProps>) => {
  const theme = useTheme()

  const {
    users,
    shouldUpdateTextfield,
    value: html,
    mentionedCounter,
    mentionedContainerClass,
    setText,
    setMentions,
    resetMentioningRef,
    setCharacterCount
  } = props

  return (
    <>
      {users
        .filter(item => !!item)
        .map(user => (
          <StyledMentionable
            key={user?.id}
            style={{
              cursor: 'pointer',
              color: theme.colors.accent1
            }}
            onClick={event => {
              if (shouldUpdateTextfield ?? true) {
                const value = html

                const asperandPos = value.indexOf('@')
                const query = mentionedCounter > 0 ? value.slice(asperandPos, asperandPos + mentionedCounter + 1) : '@'

                const newTitle = value
                  .replace(
                    query,
                    `<a href="/${user.isMember ? 'profile' : 'company'}/${
                      user.id
                    }" class="${mentionedContainerClass}" id="${user.id}">${
                      user.display
                    }</a>&nbsp;`
                  )
                  .replace('@', '')
                const newLines = newTitle.split('<div>').length - 1
                if (setCharacterCount) setCharacterCount(getHTMLTextLength(newTitle) + newLines)
                setText(newTitle)
              } else {
                setText('')
              }

              setMentions(prev => {
                prev.set(user.id, {
                  ...user,
                  element: document.getElementById(user.id)
                })

                return prev
              })

              resetMentioningRef?.current()
            }}
          >
            <Avatar src={user.image} alt="member with a profile" style={{ width: '2rem', height: '2rem' }} />
            <Box width="calc(100% - 2rem)" paddingLeft="1rem" paddingRight="1rem" boxSizing="border-box">
              <StyledEllipsisBox>{user.display}</StyledEllipsisBox>
              <StyledEllipsisBox color={theme.colors.accent}>
                {
                  user?.onboardingQuestions?.find(
                    question => question.question === (user.isMember ? 'Headline' : 'Industry')
                  )?.answer
                }
              </StyledEllipsisBox>
            </Box>
          </StyledMentionable>
        ))}
    </>
  )
}
